(() => {
 const config=window.VeloraShop;
 if(!config)return;
 const escapeHtml=value=>String(value||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const root=config.root;
 const policyLink=(url,label)=>url?`<p><a class="link-arrow" href="${escapeHtml(url)}">${label} →</a></p>`:'';
 modalContent.account=['Il mio account',`<p>Accedi al tuo account e ai tuoi ordini.</p><a class="cta" href="${escapeHtml(config.accountUrl)}">Accedi al mio account</a>`];
 modalContent.tracking=['Segui il mio ordine',`<p>Il link di tracciamento si trova nella conferma di spedizione ricevuta via e-mail. Puoi consultare i tuoi ordini anche dal tuo account.</p><a class="cta" href="${escapeHtml(config.accountUrl)}">I miei ordini</a>`];
 modalContent.contact=['Contattaci',`<p>Trova il modulo e i recapiti del servizio clienti.</p><a class="cta" href="${root}pages/contact">Contatta Velora</a>`];
 modalContent.delivery=['Spedizione e resi',policyLink(config.policies.delivery,'Politica di spedizione')+policyLink(config.policies.returns,'Politica di reso')||'<p>Le condizioni di spedizione e reso sono in preparazione.</p>'];
 modalContent.legal=['Note legali',policyLink(config.policies.legal,'Consulta le note legali')||'<p>Le note legali sono in preparazione.</p>'];
 modalContent.privacy=['Privacy',policyLink(config.policies.privacy,'Informativa sulla privacy')||'<p>L’informativa sulla privacy è in preparazione.</p>'];
 modalContent.preview=['Anteprima Shopify', '<p>Anteprima Velora: gli acquisti sono disattivati durante la preparazione del catalogo.</p><p>Il configuratore include i tre set, le taglie, le tonalità e gli omaggi.</p>'];
 const badge=document.querySelector('.preview-badge');
 if(badge)badge.hidden=!config.preview;
 const note=document.querySelector('.cart-demo');
 if(note)note.textContent=config.preview?'Anteprima Shopify · Ordini disattivati.':'Pagamento sicuro con Shopify';
 async function request(path,data){
  const response=await fetch(root+path,{method:data?'POST':'GET',credentials:'same-origin',headers:data?{'Content-Type':'application/json'}:{},body:data?JSON.stringify(data):undefined});
  const result=await response.json();
  if(!response.ok)throw new Error(result.description||result.message||'Impossibile aggiornare il carrello. Riprova.');
  return result;
 }
 const selectionKey=c=>'it:'+c.pack+':'+c.items.map(i=>i.shade+'/'+i.size).join('|');
 const propsFor=c=>{
  const props={_velora_bundle:c.pack,_velora_key:selectionKey(c),_velora_selection:JSON.stringify(c.items)};
  c.items.forEach((item,i)=>props['Collant '+(i+1)]=shadeLabel(item.shade)+' · '+item.size);
  return props;
 };
 document.querySelector('#checkout').onclick=async()=>{
  if(config.preview||!config.productAvailable){
   document.querySelector('#modal-content').innerHTML='<span class="eyebrow">ANTEPRIMA SHOPIFY</span><h2 id="modal-title">Il negozio è in preparazione.</h2><p>La tua selezione è stata salvata. Gli ordini saranno disponibili quando il prodotto verrà attivato.</p>';
   document.querySelector('#modal').showModal();return;
  }
  if(!cartItems.length)return;
  const button=document.querySelector('#checkout');button.disabled=true;
  document.querySelector('#cart-feedback').textContent='Preparazione del pagamento sicuro…';
  try{
   const product=await request('products/'+config.productHandle+'.js');
   for(const c of cartItems){
    const variant=product.variants.find(v=>v.id===config.variants[c.pack]);
    if(!variant||!variant.available)throw new Error('Questo set non è attualmente disponibile.');
    if(variant.price!==cents(c.pack))throw new Error('Il prezzo di questo set è cambiato. Ricarica la pagina prima di continuare.');
   }
   const existing=await request('cart.js');
   const desired=new Map();
   for(const c of cartItems){const key=selectionKey(c);const prior=desired.get(key);if(prior)prior.quantity+=c.quantity;else desired.set(key,{id:config.variants[c.pack],quantity:c.quantity,properties:propsFor(c)});}
   const updates={},newItems=[];
   for(const line of existing.items){
    if(!line.properties?._velora_key)continue;
    const want=desired.get(line.properties._velora_key);
    updates[line.key]=want?want.quantity:0;
    if(want)desired.delete(line.properties._velora_key);
   }
   for(const want of desired.values())newItems.push(want);
   if(newItems.length)await request('cart/add.js',{items:newItems});
   if(Object.keys(updates).length)await request('cart/update.js',{updates});
   const confirmed=await request('cart.js');
   const requestedQuantity=cartItems.reduce((n,c)=>n+c.quantity,0);
   const actualQuantity=confirmed.items.filter(i=>i.properties?._velora_key).reduce((n,i)=>n+i.quantity,0);
   if(requestedQuantity!==actualQuantity)throw new Error('Controlla il carrello prima di continuare.');
   window.location.assign(root+'checkout?locale=it');
  }catch(error){document.querySelector('#cart-feedback').textContent=error.message;button.disabled=false;}
 };
})();
